'use client'

import React, { createContext, useContext } from 'react'
import type { Texts } from './getTexts'

const LanguageContext = createContext<Texts>(null!)

export function LanguageProvider({ texts, children }: { texts: Texts; children: React.ReactNode }) {
    return <LanguageContext.Provider value={texts}>{children}</LanguageContext.Provider>
}

export function useTexts(): Texts {
    return useContext(LanguageContext)
}
